
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import { getCircular } from "../Service/Api";

const Magazine = () => {
  useEffect(() => {
    document.title = "Magazine - The Air Force School Subroto Park";
  }, []);

  const [data, setData] = useState([]);
  const [filterData, setFilteredData] = useState([]);
  const [selectedYear, setSelectedYear] = useState("All");
  const [selectedMonth, setSelectedMonth] = useState("All");
  const [yearRanges, setYearRanges] = useState([]);
  const [availableMonths, setAvailableMonths] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const monthsOfYear = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
  ];

  const handleMonth = (month) => {
    return monthsOfYear[month - 1];
  };

  // Format date as DD-MM-YYYY
  const formatDate = (date) => {
    if (!date) return "";

    const parsedDate = new Date(date);

    if (isNaN(parsedDate.getTime())) return "";

    const day = String(parsedDate.getDate()).padStart(2, "0");
    const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
    const year = parsedDate.getFullYear();

    return `${day}-${month}-${year}`;
  };

  // Fetch magazine data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const galleryData = await getCircular();

        setData(Array.isArray(galleryData) ? galleryData : []);

        const uniqueYears = Array.from(
          new Set(
            galleryData
              .filter((item) => item.date && !isNaN(new Date(item.date)))
              .map((item) => new Date(item.date).getFullYear())
          )
        ).sort((a, b) => b - a);

        setYearRanges(uniqueYears);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // Filter and sort data
  useEffect(() => {
    let filteredData = [...data];
    let monthsSet = new Set();

    // Year filter
    if (selectedYear !== "All") {
      filteredData = filteredData.filter((item) => {
        if (item.date) {
          const date = new Date(item.date);

          if (
            !isNaN(date.getTime()) &&
            date.getFullYear() === parseInt(selectedYear)
          ) {
            monthsSet.add(date.getMonth() + 1);
            return true;
          }
        }

        return false;
      });
    } else {
      data.forEach((item) => {
        if (item.date) {
          const date = new Date(item.date);

          if (!isNaN(date.getTime())) {
            monthsSet.add(date.getMonth() + 1);
          }
        }
      });
    }

    // Month filter
    if (selectedMonth !== "All") {
      filteredData = filteredData.filter((item) => {
        const date = item.date ? new Date(item.date) : null;

        return (
          date &&
          !isNaN(date.getTime()) &&
          date.getMonth() + 1 === parseInt(selectedMonth)
        );
      });
    }

    // Search filter
    if (searchQuery.trim()) {
      filteredData = filteredData.filter((item) =>
        item.title?.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Descending order (latest date first)
    filteredData.sort((a, b) => {
      const dateA = a.date ? new Date(a.date).getTime() : 0;
      const dateB = b.date ? new Date(b.date).getTime() : 0;

      return dateB - dateA;
    });

    setAvailableMonths([...monthsSet].sort((a, b) => a - b));
    setFilteredData(filteredData);
  }, [selectedYear, selectedMonth, searchQuery, data]);

  return (
    <>
      <Header />

      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>Academics</li>
          <li>Magazine / Newsletter</li>
        </ul>
      </div>

      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Magazine / Newsletter</h1>
            </div>
          </div>

          {/* Filters */}
          <div className="row tabs-dynamic">
            <div className="col-md-3">
              <div className="month-selection">
                <select
                  id="yearSelection"
                  onChange={(e) => {
                    setSelectedYear(e.target.value);
                    setSelectedMonth("All");
                  }}
                  value={selectedYear}
                >
                  <option value="All">All Years</option>

                  {yearRanges.map((yr, index) => (
                    <option key={index} value={yr}>
                      {yr}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-md-3">
              <div className="month-selection">
                <select
                  id="monthSelection"
                  onChange={(e) => setSelectedMonth(e.target.value)}
                  value={selectedMonth}
                >
                  <option value="All">All Months</option>

                  {availableMonths.map((month) => (
                    <option key={month} value={month}>
                      {handleMonth(month)}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-md-3">
              <div className="searchBox">
                <input
                  type="text"
                  id="myInput"
                  name="name"
                  autoComplete="off"
                  placeholder="Search Here.."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="clr"></div>

          {/* Magazine List */}
          <div className="row">
            {filterData.filter(
              (item) => item.category === "Magazine"
            ).length > 0 ? (
              filterData
                .filter((item) => item.category === "Magazine")
                .map((item, index) => (
                  <div className="col-lg-4" key={item._id || index}>
                    <Link
                      to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item?.attachments?.[0]}`}
                      target="_blank"
                    >
                      <div className="sample-blk">
                        <div>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: item.title,
                            }}
                          />

                          <span>{formatDate(item.date)}</span>
                        </div>

                        <img
                          alt="The Air Force School Subroto Park"
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/pdf.png"
                          className="img-fluid"
                        />
                      </div>
                    </Link>
                  </div>
                ))
            ) : (
              <div className="col-lg-4">
                <div className="sample-blk">
                  <div>
                    <p>No Magazine Available</p>
                    <span>DD-MM-YYYY</span>
                  </div>

                  <img
                    alt="The Air Force School Subroto Park"
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/pdf.png"
                    className="img-fluid"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Magazine;
